<template>
  <div class="classmatter">
        <navbar :title="text_title"></navbar>
        <div class="topbanner">
            <video autoplay controls
            name="media"  class="videoSize" width="100%" height="100%" 
            :src="videourl" v-show="this.backtype == 5 || 233 || 232 || 234 ||235" id="media"
            ></video>
        </div>
        <van-tabs v-model="activeName" title-active-color="#000" title-inactive-color="#828282">
            <van-tab title="课程列表" name="a">
                <div class="zhibolist" 
                    v-for="(sectionlist,index) in section"
                    v-bind:key="sectionlist.id"
                    @click="hrefclick(sectionlist,index)"
                    :class='{ color:index===number}'>
                    <div id="color"> 
                        <img src="@/assets/videoico.png" alt="">
                        <p>{{sectionlist.sc_name}}</p>   
                    </div>
                </div>
            </van-tab>
            <van-tab title="课程介绍" name="b">
                <img src="../../assets/tongbuback.png" width="100%" alt="" v-show=" this.backtype == 5">
                <img src="../../assets/zhishidianback.png" width="100%" alt="" v-show=" this.backtype == 233">
                <img src="../../assets/zhuantibanck.png" width="100%" alt="" v-show=" this.backtype == 232">
                <div v-show=" this.backtype == 234">
                    <p class="text">{{this.text}}</p>
                </div>
                <div v-show=" this.backtype == 235">
                    <p class="text">{{this.text}}</p>
                </div>
                <div v-show=" this.backtype == 239">
                    <p class="text">{{this.text}}</p>
                </div>
            </van-tab>
        </van-tabs>

        <van-loading class="login_btn2 loadingshow" v-if="load" type="spinner">加载中...</van-loading>
  </div>
</template>

<script>
import navbar from '../../components/Navbar'
import URL from '@/api/index'
import '@/assets/classmatter.css'
import http from '@/plugins/http.js'
//折叠面板
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import $ from 'jquery'
Vue.use(Tab);
Vue.use(Tabs);
import { Collapse, CollapseItem } from 'vant';
Vue.use(Collapse);
Vue.use(CollapseItem);
//栅格
import { Col, Row } from 'vant';
Vue.use(Col);
Vue.use(Row);
Vue.use(http)
//按钮
import { Button } from 'vant';
Vue.use(Button);
import { Toast } from 'vant';
Vue.use(Toast);
export default {
    components:{
        navbar
    },
    data() {
        return {
            text_title:'课程详情',
            activeName: 'a',
            course_listb:[],
            makeCourse_list:{
                subject_name:'',
                name:'',
                experience_url:'',
                profile_photo:'',
                classtime_begin:'',
                classtime_end:'',
                course_type:'',
            },
            userinfo:'',
            course_type:'',
            userInfo:'',
            btnavtive: false,
            cslist:'',
            section:'',
            load:false,
            icotype:'',
            backtype:'',
            videourl:'',
            text:'',
            number:0,

            // 数据上报字段
            client_ip:'',
            subject_id:'',
            versionslist:'',
            version:'',
            iteminfo:'',
            subjectlist:'',
            product_name:""
        }   
    }, 
    computed:{

    },
    created(){
    },
    watch:{
        
    },
    mounted(){
        // $.each(aaa,function(key,value){
        //     console.log(key,'---',value);
        // })

        this.product_name = "孺教云"
        var myVideo = document.getElementById("media");  

        // 播放
        myVideo.addEventListener('play',function(){  
            var begin = Date.parse(new Date())/1000
            localStorage.setItem('begintime', begin) // 开始时间
        });  

        // 暂停
        myVideo.addEventListener('pause',function(){  
            var end = Date.parse(new Date())/1000
            if(localStorage.getItem('retrue') == "false"){

            } else {
                localStorage.setItem('endtime', end)
                // 多次暂停  时间差计算
                if(!localStorage.getItem('differencetime')){
                    var differencetime = end - localStorage.getItem('begintime')
                    localStorage.setItem('differencetime',differencetime) // 时间差
                } else {
                    var differencetime = end - localStorage.getItem('begintime') + Number(localStorage.getItem('differencetime'))
                    localStorage.setItem('differencetime',differencetime) // 时间差
                }
            }
        })  


        if (localStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        }
        this.csid = this.$route.query.csid;
        this.icoType = this.$route.query.icoType

        // 视频列表
        this.getcourseinfo();
    },
    methods:{
        // 视频列表
        getcourseinfo(){
            this.load = true
            this.$axios({
                method: "post",
                url: 'http://api.rujiaowang.net/index.php/api/newcourse/get_course_info',
                data: {
                    cs_id: this.csid,
                },
            }).then(item => {
                localStorage.setItem('videodata',JSON.stringify(item.data.result.section[0]))
                this.load = false
                this.cslist = item.data.result
                this.section = item.data.result.section
                this.videourl = item.data.result.section[0].yun_url
                this.backtype = item.data.result.top_id
                this.text = item.data.result.cs_brief
                this.subject_id = item.data.result.subject_id

                // 版本获取
                this.getbooklist()
                this.getsubject()
                this.getuser()
            })
        },
        // 切换视频
        hrefclick(csinfo,index){
            console.log(123);
            if (this.userInfo == null || this.userInfo.token == null) {
                this.$router.push({path:'/login'})
                return;
            }else{
                this.videourl = csinfo.yun_url
                this.number = index;

                // 切换视频，两个开始时间相减，获取差值
                if(!localStorage.getItem('endtime')){
                    var differencetime = Number(Date.parse(new Date())) / 1000 - localStorage.getItem('begintime')
                    localStorage.setItem('differencetime',differencetime) // 时间差
                } else {
                    if(localStorage.getItem('begintime') > localStorage.getItem('endtime')){
                        console.log('播放中切换');
                        if(localStorage.getItem('differencetime')){
                            var differencetime = Number(Date.parse(new Date())) / 1000 - Number(localStorage.getItem('begintime')) + Number(localStorage.getItem('differencetime'))
                        } else {
                            var differencetime = Number(Date.parse(new Date())) / 1000 - Number(localStorage.getItem('begintime'))
                        }
                        localStorage.setItem('differencetime',differencetime) // 时间差
                    } else {
                        console.log('暂停中切换')
                    }
                }
                this.videowork()
            }
        },

        // 数据上报
        // 个人信息 
        getuser(){
            this.$axios({
                method: "post",
                url: 'https://api.rujiaowang.net/index.php/api/user/get_user',
                data: {
                token: localStorage.getItem('token'),
                },
            }).then(res =>{
                this.iteminfo = res.data.result
            })
        },
        // 版本
        getbooklist(){
            this.$axios({
                method:'post',    
                url:URL.getbooklist,
            }).then((res)=>{
                this.versionslist = res.data.result
                for (let j = 0; j < this.versionslist.length; j++) {
                   if(this.cslist.press_id == this.versionslist[j].pre_id){
                       this.version = this.versionslist[j].press
                   }
                }
            })
        },
        // 课本
        getsubject(){
            this.$axios({
            method:'post',    
            url:URL.get_subject_list,
            data:{
                gid:''
            }
            }).then((res)=>{
                this.subjectlist = res.data.result
                for (let j = 0; j < this.subjectlist.length; j++) {
                   if(this.subject_id == this.subjectlist[j].subject_id){
                       this.subject = this.subjectlist[j].subject_name
                   }
                }
            })
        },
        // 视频播放上报
        videowork(){
            this.$axios({
                method: "get",
                url: 'http://access.rujiaowang.net/GetLogServer',
                data: {
                    token: localStorage.getItem('token'),
                },
            }).then(res =>{
                this.client_ip = res.data.result.client_ip
                var actualtime = res.data.result.net_ts - Date.parse(new Date()) / 1000 // 服务器时间跟计算机时间差值

                var video_time = localStorage.getItem('differencetime')
                var videodata = JSON.parse(localStorage.getItem('videodata'))
                var traceid =  localStorage.getItem('trace')
                var app_traceid =  localStorage.getItem('apptrace')
                if(JSON.parse(localStorage.getItem("userInfo")).user_type == 3){
                    var school_name = String(this.iteminfo.school) //学校
                    var school_id = String(this.iteminfo.school_id) //学校id
                    var data1 = {
                        school_name: school_name,
                        school_id: school_id,
                        trace_id: app_traceid,
                        subject_name: this.subject,
                        subject_id: this.subject_id,
                        resource: {
                            version:this.version,
                            title_id: videodata.id,
                            title: videodata.sc_name,
                            video_time: video_time,
                        }   
                    }
                } else if(JSON.parse(localStorage.getItem("userInfo")).user_type == 5){
                    var school_name = String(this.iteminfo.school) //学校
                    var school_id = String(this.iteminfo.school_id) //学校id
                    var grade_name = String(this.iteminfo.grade) //学校id
                    var grade_id = String(this.iteminfo.grade) //学校id
                    var class_name = String(this.iteminfo.myclass) //学校id
                    var class_id = String(this.iteminfo.myclass_id) //学校id
                    var list = [
                        {id:1,text:'一'},
                        {id:2,text:'二'},
                        {id:3,text:'三'},
                        {id:4,text:'四'},
                        {id:5,text:'五'},
                        {id:6,text:'六'},
                        {id:7,text:'七'},
                        {id:8,text:'八'},
                        {id:9,text:'九'},
                    ]
                    for (let index = 0; index < list.length; index++) {
                        if(grade_id == list[index].id){
                            var grade_name = list[index].text
                        }
                    }
                    var data1 = {
                        school_name: school_name,
                        school_id: school_id,
                        grade_name: grade_name + '年级',
                        grade_id: grade_id,
                        class_name: class_name,
                        class_id: class_id,
                        trace_id: traceid,
                        subject_name: this.subject,
                        subject_id: this.subject_id,
                        resource: {
                            version:this.version,
                            title_id: videodata.id,
                            title: videodata.sc_name,
                            video_time: video_time,
                        }   
                    }
                } else if(JSON.parse(localStorage.getItem("userInfo")).user_type == 2) {
                    var data1 = {
                        trace_id: traceid,
                        subject_name: this.subject,
                        subject_id: this.subject_id,
                        resource: {
                            version:this.version,
                            title_id: videodata.id,
                            title: videodata.sc_name,
                            video_time: video_time,
                        }   
                    }
                }
                if(this.Mobile == 'pad'){
                    var saydata = {
                        log_version: "v2.0.0", 
                        action:  "synchronization_watch",
                        product_name:localStorage.getItem('product_name'),
                        user_id: String(this.iteminfo.user_id),
                        user_role: String(this.iteminfo.user_type),
                        ts: String(Number(Date.parse(new Date())) / 1000 + actualtime), // 真实时间
                        trace_id: localStorage.getItem('trace'),
                        dev_id: '',
                        dev_name: '',
                        client_ip: this.client_ip,
                        os: '',
                        cpu_name: '',
                        cpu_use: '',
                        app_version: 'v2.0.0',
                        mem_size: '',
                        mem_use: '',
                        net: '',
                        electric: '',
                        user_name: this.iteminfo.user_nicename,
                        "@": '',
                        extend: '',
                        remark: String(this.iteminfo.user_nicename + '学习了' + videodata.sc_name),
                        data: data1
                    }
                    $.ajax({
                        method: "post",
                        url: 'http://47.114.114.56:9002/RecordRjw',
                        data: JSON.stringify(saydata),
                    }).then(res =>{
                        if(JSON.parse(res).state == 0){
                            localStorage.removeItem('differencetime')
                            localStorage.removeItem('endtime')
                        }
                    })
                } 
                else {
                    var saydata = {
                        log_version: "v2.0.0", 
                        action:  "synchronization_watch",
                        product_name:localStorage.getItem('product_name'),
                        user_id: String(this.iteminfo.user_id),
                        user_role: String(this.iteminfo.user_type),
                        ts: String(Number(Date.parse(new Date())) / 1000 + actualtime), // 真实时间
                        trace_id: localStorage.getItem('trace'),
                        dev_id: '',
                        dev_name: '',
                        client_ip: this.client_ip,
                        os: '',
                        cpu_name: '',
                        cpu_use: '',
                        app_version: 'v2.0.0',
                        mem_size: '',
                        mem_use: '',
                        net: '',
                        electric: '',
                        user_name: this.iteminfo.user_nicename,
                        "@": '',
                        extend: '',
                        remark: String(this.iteminfo.user_nicename + '学习了' + videodata.sc_name),
                        data: data1
                    }
                    $.ajax({
                        method: "post",
                        url: 'http://47.114.114.56:9002/RecordRjw',
                        data: JSON.stringify(saydata),
                    }).then(res =>{
                        if(JSON.parse(res).state == 0){
                            localStorage.removeItem('differencetime')
                            localStorage.removeItem('endtime')
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.van-tabs /deep/ .van-tabs__line {
    width: 20px !important;
    background-color: #3c69f5;
    transform: translateX(62.5px) translateX(-50%);
}
.van-tabs /deep/{
    margin-top: 231px;
}
.van-tabs /deep/ .van-tabs__wrap{
    width: 100%;
    position: fixed;
    top: 255px;
    padding: 0;
}
.van-tabs /deep/ .van-tabs__content{
    margin-top: 275px;
}
.topbanner {
    width: 100%;
    height: 210px;
    z-index: 3;
    overflow: hidden;
    position: fixed;
    background-color: #fff;
}
.zhibolist {
    line-height: 48px;
    font-size: 14px;
    padding: 0 15px;
}
.zhibolist img {
    width: 16px;
    vertical-align: middle;
    display: inline-block;
}
.zhibolist div:first-child p {
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    margin: 0;
    vertical-align: middle;
}
.color {
    color: #3c69f5;
}
</style>


// WEBPACK FOOTER //
// src/pages/newclassdetails/newclassdetails.vue